import { useState } from "react"
import Toast, { ToastProps } from "./Toast"

interface ToastOptions {
  /** Usually left empty */
  id?: string
  content: string
  /** Duration in milliseconds to show the toast.  Default:  5 seconds.  If 0, the toast stays until destroyToast is called */
  duration?: number
  /** If true, show with "error" styling */
  error: boolean
}

let toasts: ToastProps[] = []
let renderFunc: undefined | (() => void)
function render() { setTimeout(() => { if (renderFunc) { renderFunc() } }, 0) }

export function destroyToast(id: string) {
  toasts = toasts.filter((x: ToastProps) => x.id !== id)
  render()
}
/** Returns the toast "id" which can be used in `destroyToast` */
export function showToast(options: ToastOptions): string {
  const toastId = Math.random().toString(36).substring(2, 9)
  const toast: ToastProps = {
    id: toastId,
    ...options, // if id is passed within options, it will overwrite the auto-generated one
    destroy: () => destroyToast(options.id ?? toastId),
  }
  toast.duration ??= 5000
  toasts = [toast, ...toasts]
  render()
  return toastId
}

export function ToastManager() {
  const [renderCount, setRenderCount] = useState(0)
  renderFunc = () => setRenderCount(renderCount + 1)
  return <>
    {toasts.map(x => <Toast key={x.id} {...x} />)}
  </>
}
